<template>
  <div class="idea-challenges">
    <PreContentHeader :show-loading="!contentReady" :error-message="contentLoadError"></PreContentHeader>
    <transition name="fade">
      <div v-if="contentReady && contentLoadError === ''">
        <ContentHeader :name="headerName"></ContentHeader>
        <section v-if="activeNominationEvent.length > 0">
          <div v-for="award in activeNominationEvent" v-bind:key="award.id">
            <div class="card mb-3">
              <div v-if="award._embedded['wp:featuredmedia']" class="featuredImg">
                <img v-if="award._embedded['wp:featuredmedia'][0].media_details.sizes.full.source_url"
                  :src="award._embedded['wp:featuredmedia'][0].media_details.sizes.full.source_url"
                  :alt="award._embedded['wp:featuredmedia'][0].alt_text"
                  :title="award._embedded['wp:featuredmedia'][0].title.rendered"
                >
              </div>
              <div v-html="award.content.rendered" class="card-body px-3 pb-0"></div>
              <div v-if="award.nomination_event_time_frame.length > 0">
                <ul class="fa-ul" v-if="award.nomination_event_time_frame[0][0][0].nomination_event_date_from !== ''">
                  <li class="h6">
                    <span class="fa-li"><i class="fas fa-calendar-alt fa-fw fa-sm text-black-50"></i></span>
                    {{award.nomination_event_time_frame[0][0][0].nomination_event_date_from}} -
                    {{award.nomination_event_time_frame[0][0][0].nomination_event_date_to}}
                  </li>
                </ul>
              </div>
              <!-- <ChildNominationEventsList class="px-3 pb-3" :awards="award.child_nomination_awards[0][0]" name="The awards categories are:"></ChildNominationEventsList> -->
            </div>
            <div v-if="award.additional_content.length > 0 && award.additional_content[0] !== '' && award.additional_content !== ''" class="card mb-3">
              <div class="card-body" v-html="award.additional_content[0]"></div>
            </div>
          </div>
        </section>
        <!--<section v-if="activeNominationEvent.length === 0">
          <h5 class="text-black-50 mb-4 text-center">
            <em>There are no VE Awards at present.<br>
              Check this space again sometime soon.
            </em>
          </h5>
        </section>
        <h3 class="text-white-50 bg-secondary p-3 mb-4" v-if="noExpire">Expired awards</h3>
        <section v-if="inactiveNominationEvent.length > 0 && noExpire">
          <div class="card-columns">
            <div v-for="award in inactiveNominationEvent" v-bind:key="award.id" class="card mb-3">
              <div v-if="award._embedded['wp:featuredmedia']" class="featuredImg">
                <img v-if="award._embedded['wp:featuredmedia'][0].media_details.sizes.full.source_url"
                  :src="award._embedded['wp:featuredmedia'][0].media_details.sizes.full.source_url"
                  :alt="award._embedded['wp:featuredmedia'][0].alt_text"
                  :title="award._embedded['wp:featuredmedia'][0].title.rendered"
                >
              </div>
              <div class="card-body">
                <h6 class="card-title text-center">{{award.title.rendered}}</h6>
                <ChildNominationEventsList :awards="award.child_nomination_awards[0][0]" name=""></ChildNominationEventsList>
              </div>
            </div>
          </div>
        </section>
        <section v-if="inactiveNominationEvent.length === 0 && noExpire">
          <h5 class="text-black-50 mb-4 text-center">
            <em>There are no expired Recognitions
            </em>
          </h5>
        </section>-->
      </div>
    </transition>
  </div>
</template>

<script>
import ContentHeader from '@/components/ContentHeader'
import WordpressRestAPI from '@/helpers/WordpressRestAPI.js'
import ChildNominationEventsList from '@/components/ChildNominationEventsList'
import PreContentHeader from '@/components/PreContentHeader'
import { mapGetters } from 'vuex'
export default {
  components: {
    PreContentHeader,
    ContentHeader,
    ChildNominationEventsList
  },
  data () {
    return {
      activeNominationEvent: [],
      inactiveNominationEvent: [],
      errors: [],
      contentReady: false,
      contentLoadError: '',
      noExpire: false,
      headerName: ''
    }
  },
  computed: {
    // mix the getters into computed with object spread operator
    ...mapGetters([
      'getUserCommunityIDstring'
    ])
  },
  created () {
    this.loadContent()
  },
  methods: {
    getAPiCallString: function () {
      if (!this.$store.getters.isAdmin && this.getUserCommunityIDstring !== undefined) {
        return 'community_categories=' + this.getUserCommunityIDstring
      } else {
        return ''
      }
    },
    loadContent: function () {
      document.title = this.$route.name + ' - ThinkTank'
      // WordpressRestAPI.getViewContent('nomination_event?nomination_event_category=22&_embed&' + this.getAPiCallString() + '&per_page=100')
      WordpressRestAPI.getViewContent('nomination_event?slug=' + this.$route.params.name + '&_embed')
        .then(response => {
          this.headerName = response.data[0].title.rendered
          this.activeNominationEvent = response.data.filter(x => !x.nomination_event_category.includes(35))
          this.inactiveNominationEvent = response.data.filter(x => x.nomination_event_category.includes(35))
          this.contentReady = true
        })
        .catch(e => {
          this.contentLoadError = 'Oops! We had a problem with loading the Recognitions. Please try again later.'
          console.error(e)
          this.contentReady = true
        })
    }
  },
  watch: {
    '$route' (to, from) {
      this.loadContent()
    },
    getUserCommunityIDstring (newDetails, oldDetails) {
      if (!this.$store.getters.isAdmin) {
        this.loadContent()
      }
    }
  }
}
</script>

<style lang="less">
  .featuredImg {
    img {
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/routes/VEAwards.vue